export const CARD_VARIANTS = {
    PRODUCT: 'product',
    BUNDLE: 'bundle',
    CATEGORY: 'category',
    COMPARISON: 'comparison',
}

export const TRANSACTIONAL_VARIANTS = [
    CARD_VARIANTS.PRODUCT,
    CARD_VARIANTS.BUNDLE,
    CARD_VARIANTS.COMPARISON,
]

const VARIANT_ALIASES = {
    product: CARD_VARIANTS.PRODUCT,
    products: CARD_VARIANTS.PRODUCT,
    bundle: CARD_VARIANTS.BUNDLE,
    bundles: CARD_VARIANTS.BUNDLE,
    category: CARD_VARIANTS.CATEGORY,
    categories: CARD_VARIANTS.CATEGORY,
    comparison: CARD_VARIANTS.COMPARISON,
    compare: CARD_VARIANTS.COMPARISON,
}

const normalizePicklistValue = (value) =>
    String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '')

/**
 * Resolves the layout variant of a tab from the Contentstack picklist, falling
 * back to the shape of the authored payload when the picklist is not set.
 */
export const getTabVariant = (tab) => {
    const picklist = normalizePicklistValue(tab?.card_type || tab?.card_layout || tab?.layout)
    if (VARIANT_ALIASES[picklist]) return VARIANT_ALIASES[picklist]

    if (tab?.categories?.length > 0) return CARD_VARIANTS.CATEGORY

    const bundles = tab?.products_bundles || []
    if (bundles.some((entry) => (entry?.product_characteristics || []).length > 0)) {
        return CARD_VARIANTS.COMPARISON
    }
    if (bundles.some((entry) => (entry?.code?.data || []).length > 1)) {
        return CARD_VARIANTS.BUNDLE
    }

    return CARD_VARIANTS.PRODUCT
}

const getEntryKey = (entry, index) => entry?._metadata?.uid || `carousel-card-${index}`

const mapCategoryItems = (tab) =>
    (tab?.categories || []).map((entry, index) => ({
        key: getEntryKey(entry, index),
        iconId: entry?._metadata?.uid,
        icon: entry?.icon,
        title: entry?.title,
        subtitle: entry?.subtitle || entry?.body_copy,
        image: entry?.image,
        link: {categorysfcc: entry?.category},
    }))

const mapProductItems = (tab) =>
    (tab?.products_bundles || []).map((entry, index) => ({
        key: getEntryKey(entry, index),
        contentstackProducts: (entry?.code?.data || []).filter((product) => product?.id),
        productIds: (entry?.code?.data || []).map((product) => product?.id).filter(Boolean),
        description: entry?.body_copy || entry?.subtitle,
        characteristics: (entry?.product_characteristics || []).slice(0, 5),
    }))

/**
 * Flattens a Contentstack tab into a uniform list of renderable cards.
 */
export const getTabCards = (tab) => {
    const variant = getTabVariant(tab)
    const items = variant === CARD_VARIANTS.CATEGORY ? mapCategoryItems(tab) : mapProductItems(tab)

    return {variant, items}
}

/**
 * Every SFCC product id referenced across all tabs, deduplicated for a single hydration call.
 */
export const collectProductIds = (tabs = []) => {
    const ids = tabs.flatMap((tab) =>
        (tab?.products_bundles || []).flatMap((entry) =>
            (entry?.code?.data || []).map((product) => product?.id),
        ),
    )

    return [...new Set(ids.filter(Boolean))]
}
